import authenticate from '@/middleware/authenticate'

export default [
  {
    path: '/pay-monthly-incentive-bonuses',
    name: 'pay-monthly-incentive-bonus',
    meta: { middleware: authenticate },
    component: () => import('@/pages/hr/pay-monthly-incentive-bonus')
  }
]
